// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-components-___Error__error___FZzix {
  background-color: #ff401e;
  color: #ffffff;
  text-align: center;
  padding: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/Error.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AADF","sourcesContent":["@import '../variables.less';\n\n.error {\n  background-color: @color-main-red;\n  color: @color-main-white;\n  text-align: center;\n  padding: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export var error = `src-styles-components-___Error__error___FZzix`;
export default ___CSS_LOADER_EXPORT___;
